import differenceBy from 'lodash/differenceBy';
import { BulkLicenseActionInput, User, LicenseAction } from 'types/schema-generated-types';
import { UserFormData } from '../types';
import { getAssignedProducts, getId } from 'utilities/product-utils';

export const buildUpdateUserLicensePayload = (
  values: UserFormData,
  user: User
): BulkLicenseActionInput[] => {
  const existingProducts = user?.licenseUsage ? getAssignedProducts(user.licenseUsage) : [];

  const removedProducts = differenceBy(existingProducts, values.licensedProducts, x =>
    getId(x.product, x.productCurriculum)
  );
  const addedProducts = differenceBy(values.licensedProducts, existingProducts, x =>
    getId(x.product, x.productCurriculum)
  );

  const licenseAssignment: BulkLicenseActionInput[] = [];
  removedProducts.forEach(({ product, productCurriculum }) => {
    licenseAssignment.push({
      action: LicenseAction.UNASSIGN,
      userId: user.id,
      product: { code: product.code },
      ...(productCurriculum && { productCurriculum: { code: productCurriculum.code } })
    });
  });

  addedProducts.forEach(({ product, productCurriculum }) => {
    licenseAssignment.push({
      action: LicenseAction.ASSIGN,
      userId: user.id,
      product: { code: product.code },
      ...(productCurriculum && { productCurriculum: { code: productCurriculum.code } })
    });
  });

  return licenseAssignment;
};

export const buildUpdateUserPayload = (values: UserFormData) => ({
  organizationAssociations: values.organizationRoles.map(({ organization, role }) => ({
    organizationId: organization.id,
    organizationRoleId: role.id
  }))
});
